export default defineNuxtPlugin(async (nuxtApp) => {
    const headers = useRequestHeaders(['cookie']);
    const { isDraftModeEnabled } = useDraftMode();
    const { data, error } = await useFetch<StoryblokConfigSlug[]>('/api/section-registry', {
        key: computed(() => `section-registry-${isDraftModeEnabled.value ? 'draft' : 'published'}`),
        headers
    });

    if (error.value) {
        throw createError({
            statusCode: error.value.statusCode,
            message: error.value.message,
            fatal: true
        });
    }

    const configSlugs = computed(() => data.value ?? null);

    nuxtApp.provide('subSectionRegistry', configSlugs);
});
